import React from 'react';
import PropTypes from 'prop-types';

const ScrollableTab = (props) => {
  const {
    menus,
    navClass = 'justify-content-center',
    itemClass = '',
    linkClass = '',
    linkColor = '',
  } = props;
  return (
    <div className={`d-flex ${navClass}`}>
      <ul className="nav scroll-tab" role="tablist">
        {
          Object.keys(menus).map((key, index) => {
            const strActive = index === 0 ? 'active' : '';
            return (
              <li key={`scroll-tab-item-${index}`} className={`nav-item scroll-tab__item ${itemClass}`}>
                <a id={`tab-${key}`} data-toggle="tab" role="tab" href={`#${key}`}
                   className={`nav-link scroll-tab__link ${strActive} ${linkClass}`}
                   aria-controls={key}
                   style={{ color: `${linkColor}`, borderColor: `${linkColor}` }}>{menus[key]}</a>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};

ScrollableTab.propTypes = {
  menus: PropTypes.object.isRequired,
};

export default ScrollableTab;



// WEBPACK FOOTER //
// ./src/Common/ScrollableTab.js